<div class="panel-body ">
    <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top" *ngIf="(additionalInfo.length === 0)">
        <div class="panel-title">
            Related Allegations
        </div>
        <div class="panel-body ">
            No Related Allegations information available for this event.
        </div>
    </div>
    <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top" *ngIf="(additionalInfo.length !== 0)">
      <div class="panel-title">
        Related Allegations
      </div>
     <div class="panel-body ">
       <div class="row table-responsive">
      <table id="relatedAllegations-table" class="table table-condensed table-striped">
     <thead>
       <tr>
        <th id="V122c">
          <span class="field-code ">json='eventList.pleadingTypeCode'</span><span class="field-code ">V122c json='allegations.pleadingType'</span>
          Pleading Type <br> 
          <span class="field-code ">V122c json='allegations.pleadingDate'</span><span class="field-code ">V122c json='allegations.pleadingTime'</span>
          And Clock Date
        </th>
        <th id="V121c">
          <span class="field-code ">V121c json='allegations.description'</span>
            Allegation <br>
            <span class="field-code ">V121c json='allegations.initDate'</span><span class="field-code ">V121c json='allegations.dispTimestamp'</span>
            Offense Date
          </th>
        </tr>
     </thead>
     <tbody *ngFor="let issue of additionalInfo; let i = index">
       <!-- <tr *ngFor="let attorney of civilCase.getAttorneyList(); let i = index">
         <td id="{{'civil-caseDetails-attorneys-' + i + '-dateTime' }}">{{allegations.getDateTime()}}</td>
         <td id="{{'civil-caseDetails-attorneys-' + i + '-eventTypeOutcome'}}">{{allegations.EventTypeOutcome()}}</td>
         <td id="{{'civil-caseDetails-attorneys-' + i + '-result'}}">{{allegations.getResult()}}</td>
         <td id="{{'civil-caseDetails-attorneys-' + i + '-more'}}">{{allegations.getMore()}}<span class="glyphicon glyphicon-comment"></span></td>
       </tr> -->

       <tr >
        <td id="{{'juvenile-caseDetails-events-' + i + '-pleadingType'}}">
          <!-- {{issue.getPleadingTypeCode() + ' - ' + issue.getPleadingType()}}  <br> -->
          {{issue.getPleadingTypeDesc()}} <br>
          {{issue.getPleadingDate() | date:'MM/dd/yyyy'}} {{issue.getPleadingTime()}}</td>
        <td id="{{'juvenile-caseDetails-events-' + i + '-allegationDescription'}}">
          {{issue.getAllegationDescription()}} <br>        
          {{issue.getAllegationOffenseDate() | date:'MM/dd/yyyy'}} {{issue.getAllegationOffenseTime()}}</td>
      </tr>     

     </tbody>
     </table>
     </div>
    </div>
   </div>
 </div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/events/events-additional-info/related-allegations/related-allegations.component.html